<script setup>
// [xleaders] XO-07 — lối vào chính của ticket: sale có số từ CRM nhưng CHƯA có hội thoại nào, nên
// không có panel khách để bấm. Nút này đứng ở hàng Lọc/Sắp xếp phía trên danh sách hội thoại và
// chỉ hiện khi đang xem một inbox Zalo cá nhân — inbox đã xác định sẵn nên không cần bước chọn
// tài khoản như nút ở panel khách.
import { ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useZaloFriendRequest } from 'dashboard/composables/useZaloFriendRequest';

import NextButton from 'dashboard/components-next/button/Button.vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import Input from 'dashboard/components-next/input/Input.vue';

const props = defineProps({
  inboxId: { type: [String, Number], required: true },
});

const route = useRoute();
const router = useRouter();
// Ở đây sale vừa tự gõ số, nên `phone_required` nghĩa là "số vừa gõ không dùng được", chứ không
// phải "khách chưa có số điện thoại" như ở panel khách.
const { isSending, sendFriendRequest } = useZaloFriendRequest({
  phoneRequiredKey: 'CONTACT_PANEL.ZALO_FRIEND.PHONE_INVALID',
});

const dialogRef = ref(null);
const phone = ref('');

const onSubmit = async () => {
  const data = await sendFriendRequest(props.inboxId, { phone: phone.value });
  if (!data) return;

  dialogRef.value?.close();
  // Sale đang đứng ở màn hình danh sách và chờ thấy kết quả — mở thẳng hội thoại vừa tạo. Hai chi
  // tiết dễ sai: điều hướng bằng `display_id` chứ KHÔNG phải `conversation_id` (khoá chính), và
  // dùng route `conversation_through_inbox` để sale ở lại đúng inbox Zalo — `inbox_conversation`
  // hardcode `inboxId: 0` nên sẽ ném sale về "tất cả hội thoại".
  router.push({
    name: 'conversation_through_inbox',
    params: {
      accountId: route.params.accountId,
      inbox_id: props.inboxId,
      conversation_id: data.conversation_display_id,
    },
  });
};
</script>

<template>
  <NextButton
    v-tooltip.top-end="$t('CONTACT_PANEL.ZALO_FRIEND.BUTTON')"
    icon="i-ph-user-plus"
    slate
    xs
    faded
    @click="dialogRef?.open()"
  />

  <Dialog
    ref="dialogRef"
    :title="$t('CONTACT_PANEL.ZALO_FRIEND.DIALOG_TITLE')"
    :confirm-button-label="$t('CONTACT_PANEL.ZALO_FRIEND.SUBMIT')"
    :is-loading="isSending"
    :disable-confirm-button="!phone.trim()"
    width="md"
    @confirm="onSubmit"
    @close="phone = ''"
  >
    <Input
      v-model="phone"
      type="tel"
      autofocus
      :label="$t('CONTACT_PANEL.ZALO_FRIEND.PHONE_LABEL')"
      :placeholder="$t('CONTACT_PANEL.ZALO_FRIEND.PHONE_PLACEHOLDER')"
    />
  </Dialog>
</template>
